import {
  ArrowCircleLeftOutlined,
  ArrowCircleRightOutlined,
} from "@mui/icons-material";
import {
  Card,
  Grid2,
  FormControlLabel,
  Checkbox,
  Tooltip,
  IconButton,
  Typography,
} from "@mui/material";
import { showLoadingImage } from "../Utility/Utility";
import AvailableSlots from "./AvailableSlots";
import {
  addDays,
  getDateOnlyAsString,
  getDatesArray,
} from "../Utility/DateTimeUtility";
import { getAvailableSlots } from "../API/AppointmentsApi";
import { useContext, useEffect, useRef, useState } from "react";
import AuthContext from "../Context/AuthProvider";
import dayjs from "dayjs";

function SlotSelector({
  isWalkInAllowed,
  isWalkIn,
  setIsWalkIn,
  selectedService,
  selectedPhysicianId,
  selectedServiceId,
  selectedTimeSlot,
  setSelectedTimeSlot,
  dateRange,
  setDateRange,
}) {
  const [disablePreviousButton, setDisablePreviousButton] = useState(true);
  const [showSpinner, setShowSpinner] = useState(false);
  const [availableSlots, setAvailableSlots] = useState();
  const { auth } = useContext(AuthContext);
  const availableSlotsComponentRef = useRef();

  useEffect(() => {
    const getSlots = async () => {
      setShowSpinner(true);
      var result = {};

      // setSelectedServiceId(serviceId);
      // setSelectedPhysicianId(physicianId);
      if (selectedServiceId !== "" && selectedPhysicianId !== "") {
        result = await getAvailableSlots(
          dateRange,
          auth,
          selectedPhysicianId,
          selectedServiceId
        );
        if (result?.isSuccess) {
          setAvailableSlots(result?.data);
        } else {
          setAvailableSlots(undefined);
          //errorToast.show();
        }
      } else {
        setSelectedTimeSlot();
      }
      setShowSpinner(false);
    };
    getSlots();
  }, [selectedPhysicianId, selectedServiceId, dateRange, auth]);

  const onNextDateRangeClick = () => {
    const lastDateInPreviousSelection = dateRange[dateRange.length - 1];
    const firstDayInNextDateRange = addDays(lastDateInPreviousSelection, 1);
    const newDateRange = getDatesArray(firstDayInNextDateRange, 7);
    setDateRange(newDateRange);
    setDisablePreviousButton(false);
  };

  const onPreviousDateRangeClick = () => {
    const firstDateInPreviousSelection = dateRange[0];

    const firstDayInNextDateRange = addDays(
      firstDateInPreviousSelection,
      0 - 7
    );
    const newDateRange = getDatesArray(firstDayInNextDateRange, 7);

    setDateRange(newDateRange);
    if (newDateRange[0] === getDateOnlyAsString(new Date())) {
      setDisablePreviousButton(true);
    } else {
      setDisablePreviousButton(false);
    }
  };
  return (
    <Grid2 container size={12}>
      <Card variant="outlined">
      {isWalkInAllowed && (
        <Grid2 container size={12} sx={{ paddingLeft: "5px" }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={isWalkIn}
                onChange={(e) => {
                  setIsWalkIn(e.target.checked);
                  if (e.target.checked) {
                    setSelectedTimeSlot(dayjs());
                  } else {
                    setSelectedTimeSlot();
                  }
                  availableSlotsComponentRef?.current?.clearSelectedSlot();
                }}
              />
            }
            label="Walk-In"
          />
        </Grid2>
      )}
      {selectedService?.allowedBookingType !== "WalkIn" && (
        <Grid2 size={12} sx={{ height: "350px" }}>
          <Grid2 container size={12}>
            <Grid2 container size={1} sx={{ justifyContent: "left" }}>
              <Tooltip title="Show for previous 7 days" arrow>
                <IconButton
                  variant="contained"
                  onClick={onPreviousDateRangeClick}
                  disabled={
                    selectedPhysicianId === "" ||
                    selectedServiceId === "" ||
                    disablePreviousButton ||
                    isWalkIn
                  }
                >
                  <ArrowCircleLeftOutlined fontSize="large" />
                </IconButton>
              </Tooltip>
            </Grid2>
            <Grid2
              sx={{ alignContent: "center", justifyItems: "center" }}
              size={10}
            >
              <Typography>Available Slots</Typography>
            </Grid2>
            <Grid2 container size={1} sx={{ justifyContent: "right" }}>
              <Tooltip title="Show for next 7 days" arrow>
                <IconButton
                  variant="contained"
                  onClick={onNextDateRangeClick}
                  disabled={
                    selectedPhysicianId === "" ||
                    selectedServiceId === "" ||
                    isWalkIn
                  }
                >
                  <ArrowCircleRightOutlined fontSize="large" />
                </IconButton>
              </Tooltip>
            </Grid2>
          </Grid2>
          <div
            class="row d-flex align-items-center justify-content-start g-0"
            style={{ height: 250, overflow: "scroll" }}
          >
            {showSpinner ? (
              showLoadingImage()
            ) : selectedPhysicianId !== "" && selectedServiceId !== "" ? (
              <AvailableSlots
                ref={availableSlotsComponentRef}
                dateTimeSlots={availableSlots}
                setTimeSlot={setSelectedTimeSlot}
                disabled={isWalkIn}
              ></AvailableSlots>
            ) : (
              <label
                className="ms-1 
                    fst-italic"
              >
                Select a service and a physician to view the available slots.
              </label>
            )}
          </div>
          <div
            class="row justify-content-start align-items-center border-top g-0"
            style={{ height: 40 }}
          >
            <div class="col-12 d-flex justify-content-start">
              <label class="ms-1 fw-bold">Selected Slot:</label>
              {selectedTimeSlot ? (
                <label class="fw-bold ms-2">
                  {new Date(selectedTimeSlot).toLocaleString("en-US", {
                    weekday: "short",
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </label>
              ) : (
                <label class="fst-italic ms-2">No slot selected</label>
              )}
            </div>
          </div>
        </Grid2>
      )}
      </Card>
    </Grid2>
  );
}

export default SlotSelector;
